export function getdata() {
	var obj = {
		searchlist: [],
		tableData: [],
		searchdata: {},
		headData: [{
				title: "项目名称",
				prop: "xiangmmc",
				custom:true
			},
			{
				title: "合计",
				prop: "hej",
				AmountFormat: true,
				custom:true
			},
			{
				title: "0%",
				prop: "tax0",
				AmountFormat: true,
				custom:true

			},
			{
				title: "1%",
				prop: "tax1",
				AmountFormat: true,
				custom:true
				
			}, {
				title: "3%",
				prop: "tax3",
				AmountFormat: true,
				custom:true
				
			}, {
				title: "6%",
				prop: "tax6",
				AmountFormat: true,
				custom:true
				
			}, {
				title: "9%",
				prop: "tax9",
				AmountFormat: true,
				custom:true
				
			}, {
				title: "13%",
				prop: "tax13",
				AmountFormat: true,
				custom:true
				
			}, {
				title: "其他",
				prop: "tax99",
				AmountFormat: true,
				custom:true
			},
		],
		outputData: {
			exportType: "",
			shenbq: "",
		},
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 8,
			paginationkey: 1
		}
	}
	return obj
}
